import { FaUsers, FaFileContract, FaSignOutAlt, FaUserEdit, FaPlus, FaTimes, FaFileInvoiceDollar } from 'react-icons/fa';
import { supabase } from './supabaseClient';
import { useNavigate, useLocation } from 'react-router-dom';
import logow from './logow.png';
import './tailwind.css';

// Accetta userRole come prop
export default function SidebarAgenziaMenu({ nome, cognome, isOpen, closeSidebar, userRole }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/'; // Reindirizza al login
  };

  const getNavLinkClasses = (path) => {
    const baseClasses = "flex items-center p-4 text-gray-200 hover:bg-miobluhover hover:text-white transition-colors duration-200 cursor-pointer text-base rounded-lg";
    const activeClasses = "bg-miobluhover text-red-500 font-semibold shadow-inner"; // Colore attivo come nel broker

    let isActive = location.pathname === path;
    // Gestione speciale per la voce "Gestisci Polizze" (o la home dell'agenzia)
    if (path === '/dashboard/agenzia' && (location.pathname === '/dashboard/agenzia' || location.pathname.startsWith('/dashboard/agenzia/polizze'))) {
      isActive = true;
    }
    // Se la rotta attiva è /dashboard/agenzia/gestisci-polizze, attiva il link corretto
    if (path === '/dashboard/agenzia/gestisci-polizze' && location.pathname === '/dashboard/agenzia/gestisci-polizze') {
      isActive = true;
    }

    return `${baseClasses} ${isActive ? activeClasses : ''}`;
  };

  return (
    <aside className={`fixed top-0 left-0 h-full bg-mioblu text-white shadow-lg transform transition-transform duration-300 ease-in-out z-50
      ${isOpen ? 'translate-x-0 flex flex-col' : '-translate-x-full hidden'}
      w-full md:w-64 md:relative md:translate-x-0 md:flex md:flex-col md:flex-shrink-0 md:h-auto md:shadow-none md:z-auto`}>

      <div className="p-6 pb-4 border-b border-miobluhover text-center relative">
        <img src={logow} alt="Europassistance Logo" className="h-12 mx-auto mb-3" />
        <small className="text-gray-200 block text-sm">BUONGIORNO</small>
        <div className="text-xl font-semibold mt-1">{nome} {cognome}</div>
        <button
          onClick={closeSidebar}
          className="absolute top-4 right-4 text-white text-2xl bg-transparent border-none cursor-pointer p-1 md:hidden"
        >
          <FaTimes />
        </button>
      </div>

      <ul className="list-none p-0 my-4 flex-1 overflow-y-auto" onClick={closeSidebar}>
        {/* Gestisci Polizze (home per agenzia) - FaFileContract */}
        <li
          className={getNavLinkClasses('/dashboard/agenzia')}
          onClick={() => { navigate('/dashboard/agenzia'); }}
        >
          <FaFileContract className="mr-3 text-lg" /> <span>Gestisci Adesioni</span>
        </li>

        {/* Annulla Adesione */}  
<li
  className={getNavLinkClasses('/dashboard/agenzia/annulla-polizza')} 
  onClick={() => { navigate('/dashboard/agenzia/annulla-polizza'); }} 
>
  <FaFileInvoiceDollar className="mr-3 text-lg" /> <span>Annulla Adesione</span>
</li>

        {/* Gestisci Agenti (dell'agenzia) - FaUsers */}
        <li
          // Changed path to explicitly include /dashboard/agenzia
          className={getNavLinkClasses('/dashboard/agenzia/gestisci-agenti-agenzia')}
          onClick={() => { navigate('/dashboard/agenzia/gestisci-agenti-agenzia'); }} // Ensure this matches your App.js route
        >
          <FaUsers className="mr-3 text-lg" /> <span>Gestisci Account</span>
        </li>

        {/* Crea Agente (per l'agenzia) - FaPlus */}
        <li
          // Changed path to explicitly include /dashboard/agenzia
          className={getNavLinkClasses('/dashboard/agenzia/crea-agente')}
          onClick={() => { navigate('/dashboard/agenzia/crea-agente'); }} // Ensure this matches your App.js route
        >
          <FaPlus className="mr-3 text-lg" /> <span>Crea Account</span>
        </li>

        {/* ... Altre voci di menu specifiche per l'Agenzia ... */}
      </ul>

      {/* Sezione inferiore della sidebar */}
      <div className="p-4 flex flex-col space-y-3 border-t border-miobluhover">
        <button
          className={getNavLinkClasses('/dashboard/agenzia/profilo').replace('text-gray-200', 'text-white').replace('p-4', 'py-3 px-4')}
          onClick={() => { navigate('/dashboard/agenzia/profilo'); }}
        >
          <FaUserEdit className="mr-3 text-lg" /> Aggiorna profilo
        </button>
        <button
          className="flex items-center justify-center w-full py-3 px-4 bg-miorosso text-white rounded-md transition-colors duration-200 hover:bg-miorossohover focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="mr-3 text-lg" /> Logout
        </button>
      </div>
    </aside>
  );
}